"use strict";

const initializeCustomCollapsibleItemsListener = () => {
    $(document).on("click", ".js-custom-collapsible-item .js-custom-collapsible-item-header", function (e) {
        e.preventDefault();

        const collapsibleItems       = ".js-custom-collapsible-item";
        const $otherCollapsibleItems = $(collapsibleItems).not($(this).parents(collapsibleItems));

        $otherCollapsibleItems.removeClass("active");
        $(this).parents(collapsibleItems).toggleClass("active");
    });
};

const initializeCollapsibleItems = () => {
    const sizes = ["xs", "sm", "md", "lg", "xl"];

    sizes.forEach(function (size) {
        var selector = ".collapsible-" + size + " .title";

        $("body").on("click", selector, function (e) {
            e.preventDefault();
            $(this).parents(".collapsible-" + size).toggleClass("active");

            if ($(this).parents(".collapsible-" + size).hasClass("active")) {
                $(this).attr("aria-expanded", true);
            } else {
                $(this).attr("aria-expanded", false);
            }
        });
    });
};

const initializeSingleCollapseListener = () => {
    $(document).on("click", ".js-collapse-header", (e) => {
        const $collapseHeader        = $(e.currentTarget);
        const $collapseContentTarget = $($collapseHeader.data("collapse-target"));

        $collapseHeader.toggleClass("active", !$collapseHeader.hasClass("active"));
        $collapseContentTarget.toggleClass("collapsed", !$collapseContentTarget.hasClass("collapsed"));
        $collapseContentTarget.each((index, element) => {
            const $element = $(element);

            $element.css("max-height", $element.hasClass("collapsed") ? `${$element.prop("scrollHeight")}px` : 0);
        });
    });
};

const initializeCollapsibleListeners = () => {
    initializeCustomCollapsibleItemsListener();
    initializeCollapsibleItems();
    initializeSingleCollapseListener();
};

export default initializeCollapsibleListeners;
